import React from 'react'
import { Tooltip } from 'components/Form'

const FactoredPercentAccuracyTooltip = () => {

    return (
        <Tooltip title={"שגיאות שאינן פוגמות בהבנת הטקסט משוקללות כמילים קבילות (לדוגמא - מילים עם היסוס, חזרה ותיקון עצמי, וכן מילים עם שגיאה קלה כמו השמטת דגש)"} />
    )
}

export default FactoredPercentAccuracyTooltip